import  { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import { showToast } from "../../../components/toast";
import { I_Profile } from "../../inventory/types";
import { RingLoader } from "react-spinners";
import { Plus,  } from "lucide-react";
import ActionModal from "./action-modal";
import { capitalizeFirstLetter } from "../../../utilz/function";
import Table from "../../../components/table";
import AddRequisitionDialog from "../../../components/requisition/edit/add-requisition-dialog";


interface RequisitionItem {
  _id: string;
  name: string;
  quantity: number;
  unitPrice: number;
  total: number;
}

interface RequisitionTotal {
  subtotal: number;
  total: number;
}

interface RequisitionData {
  _id: string;
  urgencyLevel: string;
  status: string;
  dateRequired: string;
  regionName: {
    regionName: string;
  };
  sourcingOfficers: { username: string }[];
  createdBy: {
    username: string;
  };
  createdAt: string;
  name: string;
  totalPrice: number;
 
  Item: RequisitionItem[];
  requisition: RequisitionTotal;
  quantity: number;
  unitPrice: number;
  total: number;
}

const RequisitionDetails = () => {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();
  const [requisition, setRequisition] = useState<RequisitionData | null>(null);
  
  const [profile, setProfile] = useState<I_Profile | null>(null);
  const [requisitionModal, setRequisitionModal] = useState(false);

  const [modalConfig, setModalConfig] = useState<{
    isVisible: boolean;
    actionType: "approved" | "delete" | "rejected";
  }>({
    isVisible: false,
    actionType: "approved",
  });

  const columns = [
    { header: "Item", accessor: "Item" },
    { header: "Quantity", accessor: "quantity" },
    { header: "Unit Price", accessor: "unitPrice" },
    { header: "Total Price", accessor: "totalPrice" },
  ];

  const column = [
    { header: "", accessor: "subtotal" },
  ];


  const userToken = localStorage.getItem("token");
  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  const { makeRequest: getRegionById } = useRequest(
    `/purchase-requisition/${id}`,
    "GET"
  );

  const { makeRequest: deleteRequisition } = useRequest(
    `/purchase-requisition/${id}`,
    "DELETE"
  );

  const { makeRequest: approveRequisition, loading } = useRequest(
    `/purchase-requisition/${id}`,
    "PUT",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getRegionById();
      setRequisition(response?.data?.requisition || null);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

  const handleConfirmAction = async () => {
    if (modalConfig.actionType === "approved" || modalConfig.actionType === "rejected") {
      const [response] = await approveRequisition({ status: modalConfig.actionType });
    
      if (response?.status) {
        showToast(response.message, true);
        window.location.reload();
      } else {
        showToast(response?.message, false);
      }
    }
    else if (modalConfig.actionType === "delete") {
      const [response] = await deleteRequisition();
      if (response?.status) {
        showToast(response.message, true);
        navigate("/dashboard/requisition");
      } else {
        showToast(response?.message, false);
      }
    }
  };

  const handleApprove = () => {
    setModalConfig({
      isVisible: true,
      actionType: "approved",
    });
  };

  const handleDecline = () => {
    setModalConfig({
      isVisible: true,
      actionType: "rejected",
    });
  };

  const handleDelete = () => {
    setModalConfig({
      isVisible: true,
      actionType: "delete",
    });
  };

  function closeDiscountModal() {
    setRequisitionModal(false);
  }

  function openSupplierModal() {
    setRequisitionModal(true);
  }


  
  const combinedData = requisition?.Item ? 
    requisition.Item.map((item) => ({
      Item: (
        <div>
          <div>{capitalizeFirstLetter(item?.name)}</div>
        </div>
      ),
      quantity: (
        <div>
          <div>{item?.quantity}</div>
        </div>
      ),
      unitPrice: (
        <div>
          <div>₦ {item?.unitPrice || "N/A"}</div>
        </div>
      ),
      totalPrice: (
        <div>
          <div>₦ {item?.total || "N/A"}</div>
        </div>
      ),
    })) 
    : 
    requisition ? 
      [{
        Item: (
          <div>
            <div>{capitalizeFirstLetter(requisition?.name)}</div>
          </div>
        ),
        quantity: (
          <div>
            <div>{requisition?.quantity}</div>
          </div>
        ),
        unitPrice: (
          <div>
            <div>₦ {requisition?.unitPrice || "N/A"}</div>
          </div>
        ),
        totalPrice: (
          <div>
            <div>₦ {requisition?.totalPrice || "N/A"}</div>
          </div>
        ),
      }] 
      : [];

  const combinedDatas = requisition?.Item ? [
    {
      subtotal: (
        <div className="w-full flex justify-between items-center p-2">
          <div className="font-medium">Sub Total</div>
          <div>₦{requisition?.requisition?.subtotal || "N/A"}</div>
        </div>
      )
    },
    {
      subtotal: (
        <div className="w-full flex justify-between items-center p-2">
          <div className="font-medium">Total</div>
          <div>₦{requisition?.requisition?.total || "N/A"}</div>
        </div>
      )
    }
  ] : [];
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar profile={profile as I_Profile} />

      <main className="flex-1 container mx-auto py-6">
        <div className="flex justify-between gap-5 mt-5 mx-10">
          <div className="flex gap-4">
            <div
              onClick={() => navigate(-1)}
              className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer"
            >
              <Icon name="appbackIcon" className="mt-1" /> Back to Requisition
            </div>

            <h1 className="md:text-[30px] -mt-2 font-bold">
              {/* {requisition?.regionName?.regionName} */}
            </h1>
          </div>

          <div className="text-[14px] flex gap-2">
          {requisition?.status !== "pending" && (
            <>

              <button
                type="button"
                className="font-normal flex border gap-1 rounded-full p-2"
                onClick={openSupplierModal}
              >
                <Icon name="editIconBlack" /> Edit
              </button>
              <button
                type="button"
                className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                onClick={handleDelete}
              >
                <Icon name="markIcon" /> Delete
              </button>

              

              {requisition?.status !== "rejected" && (
                <button
                  type="button"
                  className="font-normal flex bg-[#047401] text-[#fff] border gap-1 rounded-full p-2"
                  onClick={handleApprove}
                >
                  <Plus /> Convert to Purchase Order
                </button>
              )}
            </>
          )}

            {requisition?.status === "pending" && (
              <div className="flex gap-2">
                <button
                  type="button"
                  className="font-normal flex border gap-1 rounded-full p-2"
                  onClick={openSupplierModal}
                >
                  <Icon name="editIconBlack" /> Edit
                </button>

                <button
                  type="button"
                  className="font-normal flex bg-[#047401] text-[#fff] border gap-1 rounded-full p-2"
                  onClick={handleApprove}
                >
                  <Icon name="cancelIcon" /> Approve
                </button>

                <button
                  type="button"
                  className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                  onClick={handleDecline}
                >
                  <Icon name="markIcon" /> Decline
                </button>
                <button
                  type="button"
                  className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                  onClick={handleDelete}
                >
                  <Icon name="markIcon" /> Delete
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6 mt-5 mx-10 mb-20">
          <div className="col-span-2">
            {combinedData?.length > 0 ? (
                <div>
                    <div className="bg-white rounded-3xl shadow border border-[#C9C9C9]">
                        <Table
                            columns={columns}
                            data={combinedData}
                            selectedUserId={null}
                        />
                    </div>

                    
                    <div className="bg-white rounded-3xl shadow border border-[#C9C9C9] mt-5">
                    <Table
                        columns={column}
                        data={combinedDatas}
                        selectedUserId={null}
                    />
                    </div>
                    
                </div>
              
            ) : (
              <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                No Items found
              </div>
            )}
          </div>
          <div className="bg-white shadow border w-full border-[#C9C9C9] col-span-1">
            <h2 className="text-lg font-semibold mb-4 px-6 py-3">
              Requisition Information
            </h2>

            <div className="border-t pt-4 p-6 mt-5">
              <div className="flex flex-col gap-4">
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="users" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Requisition ID</p>
                    <p className="font-medium capitalize">{requisition?._id}</p>
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="users" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Created By</p>
                    <p className="font-medium capitalize">
                      {requisition?.createdBy?.username}
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="users" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">
                      Assigned Sourcing Officers
                    </p>
                    {requisition?.sourcingOfficers && requisition.sourcingOfficers.length > 0 ? (
                      requisition.sourcingOfficers.map((officer, index) => (
                        <p key={index} className="font-medium capitalize">
                          {officer.username}
                        </p>
                      ))
                    ) : (
                      <p className="font-medium">No sourcing officers assigned</p>
                    )}
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="calender" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Date Created</p>
                    <p className="font-medium capitalize">
                      {requisition?.createdAt && new Date(requisition.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </p>
                  </div>
                </div>

                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="location" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Sourcing Region</p>
                    <p className="font-medium capitalize">
                      {requisition?.regionName?.regionName}
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="urgency" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Urgency Level</p>
                    <p className="font-medium capitalize">
                      {requisition?.urgencyLevel}
                    </p>
                  </div>
                </div>
                <div className="flex gap-4 items-center">
                  <div className="bg-[#E8F2E8] rounded-full p-3">
                    <Icon name="status" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-sm mb-1">Status</p>
                    <p className="font-medium capitalize">{requisition?.status}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <RingLoader color="#ffffff" loading={loading} size={20} />
        ) : (
          <ActionModal
            visible={modalConfig.isVisible}
            onCancel={() => setModalConfig({ ...modalConfig, isVisible: false })}
            onConfirm={handleConfirmAction}
            title={
              modalConfig.actionType === "approved"
                ? "Approve Requisition"
                : modalConfig.actionType === "rejected"
                ? "Decline Requisition"
                : "Delete Requisition"
            }
            content={`Are you sure you want to ${modalConfig.actionType} this requisition?`}
            actionType={modalConfig.actionType}
          />
        )}

            <AddRequisitionDialog
                isVisible={requisitionModal}
                onClose = {closeDiscountModal}
                requisition={requisition}
            />
        
      </main>
    </div>
  );
};

export default RequisitionDetails;